import type { ComponentType, SVGProps } from 'react'

import { EditIcon, FoodIcon, MealIcon, RecipeIcon, SendIcon, VideoIcon } from '~/components/icons'

/** The ways of finding something to log, each a page of its own over the diary. */
export type LoggingWay = 'camera' | 'quick' | 'send' | 'foods' | 'recipes' | 'meals'

/**
 * The ways, in the order they are offered — the nutrition spec, Logging an entry: the camera,
 * a quick entry, sending food, the account's own foods, its recipes and its meals.
 *
 * Sending food stands among them because it is one of them: it is logging done for somebody
 * else — the nutrition spec, Sending food — and a page that put a plate together for somebody
 * would be a thing nobody could find if it lived anywhere but here.
 *
 * Searching is not among them on web. They stand as glyphs along the right of the header's
 * search field, and that field is the search: a glyph opening a search beside it would be the
 * same way drawn twice.
 */
export const LOGGING_WAYS: readonly {
  way: LoggingWay
  label: string
  Icon: ComponentType<SVGProps<SVGSVGElement>>
}[] = [
  { way: 'camera', label: 'Camera', Icon: VideoIcon },
  { way: 'quick', label: 'Quick entry', Icon: EditIcon },
  { way: 'send', label: 'Send food', Icon: SendIcon },
  { way: 'foods', label: 'My foods', Icon: FoodIcon },
  { way: 'recipes', label: 'Recipes', Icon: RecipeIcon },
  { way: 'meals', label: 'Meals', Icon: MealIcon },
]
